import React, { FC, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { bookmarkPostAsync } from '../../data-layer/posts/actions';
import { useDispatch } from '../../data-layer/useDispatch';
import { DeleteFromCollectionDrawer } from '../../ui/users/DeleteFromCollectionDrawer';
import { useBackButton } from '../../utils/useBackButton';
import { DEFAULT_CLOSE_ANIMATION_DELAY } from '../constants';

export const DeleteFromCollectionDialog: FC = () => {
    const { state } = useLocation();
    const postId = state?.postId;
    const collectionId = state?.collectionId;
    const dispatch = useDispatch();
    const onNavigateBack = useBackButton();

    const closeDialog = useCallback(() => {
        setTimeout(onNavigateBack, DEFAULT_CLOSE_ANIMATION_DELAY);
    }, [onNavigateBack]);

    const onDeletePostFromCollection = useCallback(() => {
        dispatch(bookmarkPostAsync(postId, collectionId));
        closeDialog();
    }, [dispatch, postId, collectionId, closeDialog]);

    const onDeletePostFromDefaultCollection = useCallback(() => {
        dispatch(bookmarkPostAsync(postId));
        closeDialog();
    }, [dispatch, postId, closeDialog]);

    if (!postId || !collectionId) {
        return null;
    }

    return (
        <DeleteFromCollectionDrawer
            onDeletePostFromDefaultCollection={onDeletePostFromDefaultCollection}
            onDeletePostFromCollection={onDeletePostFromCollection}
            handleClose={closeDialog}
        />
    );
};
